import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WorkerListItem from './WorkerListItem';

export default class WorkersListComponent extends Component {
  static propTypes = {
    workersList: PropTypes.array,
    selectedWorkersIds: PropTypes.array,
    selectAllWorkers: PropTypes.func.isRequired,
    handleWorkerSelection: PropTypes.func.isRequired,
    showNextStep: PropTypes.func.isRequired
  };

  render () {
    const { workersList, selectedWorkersIds, selectAllWorkers, handleWorkerSelection, showNextStep } = this.props;
    const showNextStepBtn = selectedWorkersIds.length > 0;
    return (
      <React.Fragment>
        <div className='select-workers-wrapper'>
          <button
            className='link-select-all-items'
            onClick={selectAllWorkers}
          >Select All</button>
          <div className='workers-list-select'>
            { workersList && workersList.map(worker => (
              <WorkerListItem
                key={worker.id}
                worker={worker}
                isSelected={selectedWorkersIds.includes(worker.id)}
                handleWorkerSelection={handleWorkerSelection}
              />
            ))}
          </div>
          { showNextStepBtn && (
            <button
              className='button button-primary employer-action-next-button mt-4'
              onClick={showNextStep}
            >
              Next
            </button>
          )}
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/TipsAndRates/WorkersListComponent.js